module.exports = __webpack_public_path__ + "static/michaela-Normal-28a0f23b9a97816ecad9602b60de88dc.jpg";